<template>
  <div class="orderDetailsPage">
    <headerNotice routerName="下一级佣金明细" v-model="SubordinateId"></headerNotice>
    <!-- 搜索条 -->
    <div class="searchBox">
      <el-form :inline="true" :model="orderDetailSearchForm" class="demo-form-inline searchForm">
        <div class="nowcustomers">
          <span>当前客户：{{Distribution.subordinateName}}</span>
        </div>

        <el-form-item style="margin-right:40px;" label="时间范围">
          <el-date-picker
            v-model="dateValue"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item style="margin-left:40px;" label="快速查看">
          <el-button type="primary" @click="onSearch">最近七天</el-button>
          <el-button type="primary" @click="onSearch">最近一个月</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="yongjing">
      <span>佣金总额：</span>
      <span>{{Distribution.totalCommissionAmount}}</span>
      <span class="xiayiji">下一级佣金：</span>
      <span>{{Distribution.nextLevelCommission}}</span>
      <span class="xiaerji">下二级佣金：</span>
      <span>{{Distribution.secondTierCommission}}</span>
      <span class="qita">其他佣金：</span>
      <span>{{Distribution.otherCommission}}</span>
    </div>
    <!-- 搜索结果列表 -->

    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="下一级佣金" name="first" :key="'first'">
        <div class="searchList" v-if="isFirst">
          <div class="searchListContent">
            <el-table
              ref="searchListTableData"
              :data="searchListTableData"
              style="width: 100%"
              show-summary
              border
              :v-loading="loading"
            >
              <el-table-column align="center" width="180" prop="username" label="成交客户"></el-table-column>
              <el-table-column align="center" width="180" prop="orderQuantity" label="订单数量"></el-table-column>
              <el-table-column align="center" prop="totalOrderaAmount" label="订单总金额"></el-table-column>
              <el-table-column align="center" prop="totalCommissionAmount" label="佣金总金额"></el-table-column>
              <el-table-column align="center" fixed="right" label="操作" width="240">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    id="btn"
                    round
                    @click="GetCommissionDetailed(scope.row)"
                  >查看佣金明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--搜索列表分页-->
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[25, 50, 75, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="下二级佣金" name="second" :key="'second'">
        <div class="searchList" v-if="isSecond">
          <div class="searchListContent">
            <el-table
              ref="searchListTableData"
              :data="searchListTableData"
              style="width: 100%"
              show-summary
              border
              :v-loading="loading"
            >
              <el-table-column align="center" width="180" prop="username" label="成交客户"></el-table-column>
              <el-table-column align="center" width="180" prop="orderQuantity" label="订单数量"></el-table-column>
              <el-table-column align="center" prop="totalOrderaAmount" label="订单总金额"></el-table-column>
              <el-table-column align="center" prop="totalCommissionAmount" label="佣金总金额"></el-table-column>
              <el-table-column align="center" fixed="right" label="操作" width="240">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    id="btn"
                    round
                    @click="GetCommissionDetailed(scope.row)"
                  >查看佣金明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--搜索列表分页-->
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[25, 50, 75, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="其他佣金" name="third" :key="'third'">
        <div class="searchList">
          <div class="searchListContent">
            <el-table
              ref="searchListTable"
              :data="searchListTableData"
              style="width: 100%"
              show-summary
              border
              :v-loading="loading"
            >
              <el-table-column align="center" width="180" prop="CommissionSource" label="佣金来源"></el-table-column>
              <el-table-column align="center" width="180" prop="CommissionRemark" label="佣金说明"></el-table-column>
              <el-table-column align="center" prop="CommissionTime" label="分佣时间"></el-table-column>
              <el-table-column align="center" prop="Commission" label="佣金"></el-table-column>
            </el-table>
          </div>
          <!--搜索列表分页-->
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[25, 50, 75, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title
      :visible.sync="CommissionDetailedFormVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <!-- 搜索框 -->
      <div class v-loading="loading">
        <div class="head">
          <h2 class="title">
            <i></i>
            <span>下级贡献金额-当前 {{username}}</span>
          </h2>
        </div>
        <el-table
          ref="couponTable"
          :data="CommissionDetailedTableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="username" label="成交客户"></el-table-column>
          <el-table-column align="center" prop="commissionTime" label="佣金时间" width="120"></el-table-column>
          <el-table-column align="center" prop="orderCode" label="订单号"></el-table-column>
          <el-table-column align="center" prop="orderAmount" label="订单金额"></el-table-column>
          <el-table-column align="center" prop="commission" label="佣金"></el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pagination"
        @size-change="couponHandleSizeChange"
        @current-change="CouponHandleCurrentChange"
        :current-page.sync="currentPage_coupon"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="couponTotalCount"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      userId: "",
      SubordinateId: "",
      loading: true,
      SkipCount: 0,
      totalCount: 0, //总数据条数

      maxResultCount: 25, //默认一页显示的个数,
      currentPage: 1,
      baseUrl: this.$store.state.apiUrl,
      dateData: [], //日期
      orderDetailSearchForm: {
        //搜索表单
        userName: "",
        StartTime: "",
        EndTime: ""
      },
      dateValue: "", //时间
      formData: {
         
          startTime: "",
          endTime: "",
         
      },
      tabclick:2,
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      username: "",
      Distribution: {
        subordinateName: "",
        totalCommissionAmount: "",
        nextLevelCommission: "",
        secondTierCommission: "",
        otherCommission: ""
      }, //佣金
      searchListTableData: [], //表单数据
      activeName: "first",
      isFirst: true,
      isSecond: false,
      isThird: false,
      row: "",
      CommissionDetailedFormVisible: false,
      CommissionDetailedForm: [],
      CommissionDetailedTableData: [],
      couponTotalCount: 0, //佣金明细总条数
      currentPage_coupon: 1,

      detailuserid:0,
    };
  },
  components: {
    headerNotice
  },
  created() {},
  mounted() {
    // this.GetDistribution()
    // console.log(this.$route.query,'row');
    this.row = this.$route.query;
    this.userName = this.row.userName;
    //  console.log(this.userName,'userName');
    //从路由提取userID
    this.onCommission(2);
    this.GetDistribution();
  },
  methods: {
    // 日期条件查询
    onSearch() {
      if (this.tabclick == "2") {
        this.onCommission(2);
      } else if (this.tabclick == "1") {
        this.onCommission(1);
      } else {
        this.onCommission(3);
      }
      this.currentPage = 1;
    },
    dateDataChange(val) {
      if (!val) {
        this.dateData = [];
      }
    },

    //一级佣金
    onCommission(aa) {
      let self = this;
      self.loading = true;
      let SubordinateId = this.row.userId;
      //  console.log(this.row.userId,'userId')
      let params = {
        SubordinateId,
        StartTime: this.dateValue[0] || "",
        EndTime: this.dateValue[1] || "",
        CommissionSource: aa,
        Username: "",
        OrderCode: "",
        SkipCount:self.SkipCount,
        MaxResultCount:self.maxResultCount,
      };
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Commission/GetCommissionList",
        params: params,
        success(res) {
          self.searchListTableData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },
    //获取总佣金
    GetDistribution() {
      let self = this;
      self.loading = true;
      let SubordinateId = Number(this.row.userId);
      //    console.log(this.row,'111')
      //  console.log(this.row.userId,'userId2'
      let params = {
        SubordinateId,
        StartTime: "",
        EndTime: "",
        CommissionSource: 2,
        Username: this.userName,
        OrderCode: "",
        SkipCount: this.SkipCount
      };
      console.log(params, "params");
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Commission/GetCommissionDetailedTotal",
        params: params,
        success(res) {
          self.Distribution = res;
          console.log(self.Distribution);
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },
    //佣金明细
    GetCommissionDetailed(row) {
      // console.log(row, "row");

        let tabclick=this.tabclick
      let self = this;
      self.loading = true;
      let SubordinateId = Number(this.row.userId);
      this.CommissionDetailedFormVisible = true;
      let userId = Number(row.userId);
      this.detailuserid = userId;
      this.username = row.username;
      // let tabclick=this.tabclick
       console.log(row.userId,'userId2')
      let params = {
        userId,
        SubordinateId,
        CommissionSource:tabclick,
        skipCount:0,
        MaxResultCount:10,
      };
      this.GetCommissionDetailedlist(params);
      
    },
//佣金明细
    GetCommissionDetailedlist(params){
        let self = this;
$http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Commission/GetCommissionDetailedList",
        params: params,
        success(res) {
          console.log(res);

          self.CommissionDetailedTableData = res.items;
          self.couponTotalCount = res.totalCount;
          // self.username = res.items[0].username;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },

    //一页显示多少个
    couponHandleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val,
        SkipCount:0,
        UserId:this.detailuserid,
        CommissionSource:this.tabclick,
      };
      this.GetCommissionDetailedlist(params);
    },
    //明细跳转到指定页
    CouponHandleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.detailuserid;
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      params.UserId = this.detailuserid;
      params.CommissionSource = this.tabclick;
      this.GetCommissionDetailedlist(params);
    },
    //搜索列表一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      if (this.isFirst) {
        this.onCommission(1);
      } else if (this.isSecond) {
        this.onCommission(2);
      }else{
        this.onCommission(3);
      }
    },
    //搜索列表跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      this.SkipCount = (val - 1) * this.maxResultCount;
      if (this.isFirst) {
        this.onCommission(1);
      } else if (this.isSecond) {
        this.onCommission(2);
      }else{
        this.onCommission(3);
      }
    },

    handleClick(tab, CommissionSource) {
      this.skipCount = 0;
      this.currentPage = 1;
      if (tab.name === "first") {
        this.isFirst = true;
        this.isSecond = false;
        this.third = false;
        this.tabclick = 2;
        this.onCommission(2);
      } else if (tab.name === "second") {
        this.isFirst = false;
        this.isSecond = true;
        this.third = false;
        this.tabclick = 1;
        this.onCommission(1);
      } else {
        this.isFirst = false;
        this.isSecond = false;
        this.third = true;
        this.tabclick = 3;
        this.onCommission(3);
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.nowcustomers {
  height: 40px;
  line-height: 40px;
  color: #606266;
  font-size: 14px;
}
.yongjing {
  margin-left: 90px;
  height: 50px;
  color: #606266;
}
.el-form--inline {
  margin-left: 90px;
}
.xiayiji,
.xiaerji,
.qita {
  margin-left: 50px;
}
</style>
